import React from "react";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import LoginHook from "../../hook/auth/LoginHook";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const LoginPage = () => {
  const [
    val,
    password,
    onChangeVal,
    onChangePassword,
    loading,
    onSubmit,
    isPress,
  ] = LoginHook();
  const settingsRes = useSelector((state) => state.settingsReducers.settings);
  const primaryColor = settingsRes?.data?.cartColor || settingsRes?.data?.primaryColor || "#3182ce";
  const { t } = useTranslation();

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onSubmit();
    }
  };

  return (
    <div className="cart-page-bg font" style={{ minHeight: "100vh", display: "flex", alignItems: "center" }}>
      <Container>
        <Row className="justify-content-center">
          <Col lg="5" md="7" sm="10" xs="12">
            <div className="checkout-section-card" style={{ padding: "40px 32px" }}>
              
              {/* Header */}
              <div className="text-center mb-4">
                <div className="d-inline-flex align-items-center justify-content-center mb-3" style={{ width: 60, height: 60, borderRadius: '50%', backgroundColor: `${primaryColor}15` }}>
                  <i className="fa-solid fa-user" style={{ fontSize: '1.5rem', color: primaryColor }}></i>
                </div>
                <h4 className="fw-bold text-dark mb-1">{t("Sign In")}</h4>
                <p className="text-muted small mb-0">{t("Email or mobile number...")}</p>
              </div>

              {/* Form */}
              <div className="mb-3">
                <label className="form-label text-muted fw-bold small">{t("Email or mobile number...")}</label>
                <div className="position-relative">
                  <i className="fa-solid fa-envelope position-absolute text-muted" style={{ top: '50%', right: '14px', transform: 'translateY(-50%)', fontSize: '0.85rem' }}></i>
                  <input
                    value={val}
                    onChange={onChangeVal}
                    onKeyDown={handleKeyDown}
                    placeholder={t("Email or mobile number...")}
                    type="text"
                    className="form-control bg-light border-0 py-3 font"
                    style={{ paddingRight: '40px' }}
                  />
                </div>
              </div>

              <div className="mb-4">
                <label className="form-label text-muted fw-bold small">{t("password...")}</label>
                <div className="position-relative">
                  <i className="fa-solid fa-lock position-absolute text-muted" style={{ top: '50%', right: '14px', transform: 'translateY(-50%)', fontSize: '0.85rem' }}></i>
                  <input
                    value={password}
                    onChange={onChangePassword}
                    onKeyDown={handleKeyDown}
                    placeholder={t("password...")}
                    type="password"
                    className="form-control bg-light border-0 py-3 font"
                    style={{ paddingRight: '40px' }}
                  />
                </div>
              </div>

              {/* Forgot Password */}
              <div className="text-end mb-4">
                <Link to="/user/forgetpassword" className="text-decoration-none small fw-bold" style={{ color: primaryColor }}>
                  {t("Forgot your password ?")}
                </Link>
              </div>

              {/* Submit */}
              <button
                disabled={isPress}
                onClick={onSubmit}
                className="btn w-100 text-white fw-bold py-3 border-0 font"
                style={{ backgroundColor: isPress ? '#a0aec0' : primaryColor, borderRadius: '10px', fontSize: '1.05rem' }}
              >
                {!loading ? <Spinner animation="border" size="sm" /> : t("Sign In")}
              </button>

              {/* Register Link */}
              <div className="text-center mt-4">
                <span className="text-muted small">{t("Don't have an account?")} </span>
                <Link to="/register" className="text-decoration-none fw-bold small" style={{ color: primaryColor }}>
                  {t("press here")}
                </Link>
              </div>

            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LoginPage;
